export const RESET_REQUEST_STATE = "RESET_REQUEST_STATE";

export const resetRequestState = (types?: string[]) => ({
    type: RESET_REQUEST_STATE,
    payload: types
});